import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { Box, Button, Divider } from '@material-ui/core';
import { FiArrowRight } from 'react-icons/fi';
import { useHistory } from 'react-router';

const useStyles = makeStyles({
    card: {
        borderRadius: 5,
        boxShadow: '0 1px 2px 0 rgb(60 64 67 / 30%), 0 1px 3px 1px rgb(60 64 67 / 15%)',
        transition: 'all  500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',

        '&:hover': {
            transform: 'translateY(-10px)',
            boxShadow: ' 0 25px 20px -20px rgb(4 41 58/71%)',
            // boxShadow: '8px 8px 30px  rgb(60 64 67/30%)',
        }
    },
    title: {
        fontSize: 22,
        fontWeight: 700,
        marginTop: 16,
        marginBottom: 32,
        transition: 'all 0.3s linear',

        '&:hover': {
            color: '#ff7731',
        }
    },
    pillButton: {
        backgroundColor: '#ff7731',
        borderRadius: 100,
        fontWeight: 700,
        marginTop: -18,
        marginLeft: 25,

        '&:hover': {
            color: '#ff7731',
            backgroundColor: '#fff'
        }
    },
    details: {
        cursor: 'pointer',
        fontSize: 14,
        fontWeight: 700,
        color: '#818181',
        marginLeft: 16,
        transition: 'all 0.3s linear',

        '&:hover': {
            color: '#ff7731',
        },
    }
    ,
    arrowButton: {
        border: '1px solid transparent',
        cursor: 'pointer',
        backgroundColor: '#DCDBDB',
        padding: 11,
        borderRadius: 3,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'all 0.3s linear',

        '&:hover': {
            color: '#ff7731',
            border: '1px solid #ff7731',
            backgroundColor: '#E9F4F3'
        },

        '&:hover $arrow': {
            color: '#ff7731',
            transform: 'translateX(5px)'
        }
    },
    arrow: {
        fontSize: 22,
        color: '#676767',
        transition: 'all 0.3s linear',
    }
});

export default function ProjectCard({ isDark, project }) {
    const classes = useStyles();
    console.log(isDark);
    const history = useHistory();

    const handleClick = (id) => {
        history.push(`/project/${id}`)
    };

    return (
        <Card className={classes.card} style={{ backgroundColor: isDark && '#171c28', border: isDark && '1px solid rgba(211, 211, 211, 0.397)', boxShadow: isDark && 'rgb(0 0 0 / 20%) 0px 10px 30px -15px' }}>
            <CardActionArea>
                <CardMedia
                    component="img"
                    alt="Contemplative Reptile"
                    height="240"
                    image={project?.image}
                    title="Contemplative Reptile"
                />
                <Button variant="contained" color="primary" className={classes.pillButton} >{project?.projectName}</Button>
                <CardContent>
                    <Typography className={classes.title} style={{ color: isDark && '#fff' }}>
                        {project?.projectDesc}
                    </Typography>
                </CardContent>
            </CardActionArea>
            <Divider style={{ backgroundColor: isDark && '#818181' }} />
            <CardActions style={{ justifyContent: 'space-between' }}>
                <Box>
                    <Typography className={classes.details} onClick={() => handleClick(project?._id)}>
                        VIEW DETAILS
                    </Typography>
                </Box>
                <Box className={classes.arrowButton} onClick={() => handleClick(project?._id)}>
                    <FiArrowRight className={classes.arrow} />
                </Box>
            </CardActions>
        </Card>
    );
}